export default class APIJWT {

    isHardValid() {
        return (
            ((this.body.HardExp - 60) > Math.floor(Date.now() / 1000))
        )
    }

    isValid() {

        return (
            this.isHardValid()
            && ((this.body.Exp - 60) > Math.floor(Date.now() / 1000))
        )
    }

    hasRole(pRole) {
        if(this.isHardValid()) {
            return this.body.Roles.includes(pRole)
        }
    }

    constructor(pJWT) {

        if (pJWT) {

            let jwt = pJWT.replaceAll("-", "+")
            jwt = jwt.replaceAll("_", "/")
            const jwtArray = jwt.split(".")
            const body = atob(jwtArray[1])
            const bodyJSON = JSON.parse(body)
            this.jwt = pJWT
            this.body = bodyJSON
        }
    }
}